export const ui = {
  componentIds: {
    cmgAppContent: 'cmg-app-content',
  },
  breakpoints: {
    phoneXxsMax: 319,
    phoneXs: 320,
    phoneXsMax: 374,
    phoneSm: 375,
    phoneSmMax: 575,
    phoneLg: 576,
    phoneLgMax: 767,
    tablet: 768,
    tabletMax: 1023,
    desktop: 1024,
    desktopMax: 1199,
    desktopLg: 1200,
  },
  colors: {
    avocado: '#90a035',
    beige: '#f7f2ed',
    beigeTwo: '#f9f7f4',
    beigeLight: '#f8f2ec',
    beigeDark: '#eae1db',
    black: '#000000',
    blueLight: '#5d5e82',
    brown: '#451400',
    brownCocoa: '#54392d',
    brownDark: '#1b0800',
    brownSubtext: '#8c766d',
    brownLight: '#786259',
    dark: '#343a40',
    greyLight: '#f0f0f0',
    greyMedium: '#f2f2f2',
    greyPinkish: '#d4cbc7',
    greyishBrown: '#756456',
    greenMedium: '#68831c',
    greenDark: '#417505',
    greenXdark: '#5f6b19',
    goldNew: '#a76721',
    gold: '#b68207',
    goldLight: '#debf79',
    goldDark: '#976500',
    goldMedium: '#c97900',
    linen: '#dfd9d3',
    pink: '#96436a',
    red: '#ad2118',
    redBurnt: '#9c1f16',
    redLight: '#d0021b',
    redDark: '#88120a',
    rustyRed: '#ac2318',
    yellowCarbs: '#d49b1c',
    white: '#ffffff',
    scarlet: '#d0021b',
  },
};

export const external = {
  stateCodes: [
    'AL',
    'AK',
    'AZ',
    'AR',
    'CA',
    'CO',
    'CT',
    'DE',
    'FL',
    'GA',
    'HI',
    'ID',
    'IL',
    'IN',
    'IA',
    'KS',
    'KY',
    'LA',
    'ME',
    'MD',
    'MA',
    'MI',
    'MN',
    'MS',
    'MO',
    'MT',
    'NE',
    'NV',
    'NH',
    'NJ',
    'NM',
    'NY',
    'NC',
    'ND',
    'OH',
    'OK',
    'OR',
    'PA',
    'RI',
    'SC',
    'SD',
    'TN',
    'TX',
    'UT',
    'VT',
    'VA',
    'WA',
    'WV',
    'WI',
    'WY',
    'DC',
  ],
  canadianProvinces: [
    { formatted: 'Alberta', value: 'AB' },
    { formatted: 'British Columbia', value: 'BC' },
    { formatted: 'Manitoba', value: 'MB' },
    { formatted: 'New Brunswick', value: 'NB' },
    { formatted: 'Newfoundland and Labrador', value: 'NL' },
    { formatted: 'Nova Scotia', value: 'NS' },
    { formatted: 'Ontario', value: 'ON' },
    { formatted: 'Prince Edward Island', value: 'PE' },
    { formatted: 'Quebec', value: 'QC' },
    { formatted: 'Saskatchewan', value: 'SK' },
    { formatted: 'Northwest Territories', value: 'NT' },
    { formatted: 'Nunavut', value: 'NU' },
    { formatted: 'Yukon', value: 'YT' },
  ],
};

export interface Country {
  countryCode: string;
  name: string;
  lat: number;
  lng: number;
  currencySymbol: string;
  currencySymbolShort: string;
  currencyName: string;
  isActive: boolean;
  isLoyaltyEnabled: boolean;
  isSustainablityEnabled: boolean;
  isAutoSubscribesToLoyaltyEmail: boolean;
  isAutoSubscribesToMarketingEmail: boolean;
  topLevelDomain: string;
  strings: CountryStrings;
  locale: string;
  validations: Validations;
}

export interface Validations {
  zipCode: {
    maxLength: number,
    formatRegex: RegExp
  }
}

export interface Countries {
  [key: string]: Country;
}

export interface CountryStrings {
  [key: string]: string;
}

export const countries: Countries = {
  us: {
    countryCode: 'US',
    name: 'United States',
    lat: 37.09024,
    lng: -95.712891,
    currencySymbol: '$',
    currencySymbolShort: '$',
    currencyName: 'US Dollars',
    isActive: true,
    isLoyaltyEnabled: true,
    isSustainablityEnabled: true,
    isAutoSubscribesToLoyaltyEmail: true,
    isAutoSubscribesToMarketingEmail: true,
    topLevelDomain: '.com',
    strings: {
      signInContainerTitle: 'Already have an account?',
    },
    locale: 'en-US',
    validations: {
      zipCode: {
        maxLength: 5,
        formatRegex:/^\d{5}$/
      }
    }
  },
  ca: {
    countryCode: 'CA',
    name: 'Canada',
    lat: 56.1304,
    lng: -106.3468,
    currencySymbol: 'CA $',
    currencySymbolShort: '$',
    currencyName: 'CA Dollars',
    isActive: true,
    isLoyaltyEnabled: true,
    isSustainablityEnabled: false,
    isAutoSubscribesToLoyaltyEmail: false,
    isAutoSubscribesToMarketingEmail: false,
    topLevelDomain: '.ca',
    strings: {
      signInContainerTitle: 'Have an account?',
    },
    locale: 'en-CA',
    validations: {
      zipCode: {
        maxLength: 7,
        formatRegex:/^[ABCEGHJ-NPRSTVXY]\d[ABCEGHJ-NPRSTV-Z] ?\d[ABCEGHJ-NPRSTV-Z]\d$/i
      }
    }
  },
};

export const enum PaymentProviders {
  Payeezy = 'PYEZ',
  Chase = 'CHAS',
}

export const RESIZE_LISTENER_POLL_RATE_MS = 50;

export const NAPKINS_AND_UTENSILS_MENU_ID = 'CMG-6110';
